/* unplugin-vue-components disabled */import script from "./app-page.vue?vue&type=script&setup=true&lang=js"
export * from "./app-page.vue?vue&type=script&setup=true&lang=js"

import "./app-page.vue?vue&type=style&index=0&id=a5718510&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5718510"]])

export default __exports__